import * as Yup from 'yup';
import {
  INVALID_FIELDS,
  serialPatternRegex,
  YupString,
  YupStringWithoutRequired,
} from './general';

export const recipientSchema = Yup.object().shape({
  profileId: YupString,
  preGhtKitId: YupStringWithoutRequired.matches(
    serialPatternRegex,
    INVALID_FIELDS.WRONG_FORMAT,
  ),
  fmtBottleId: YupString,
  postGhtKitId: YupString.matches(
    serialPatternRegex,
    INVALID_FIELDS.WRONG_FORMAT,
  ),
  createdAt: YupString,
});
